import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class UpdateReleaseFromRealtime extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UpdateReleaseFromRealtime';

    public constructor(
        public id: string,
        public name: string,
        public goal: string,
        public startDate?: string,
        public releaseDate?: string,
        public isReleased?: boolean
    ) {
        super(UpdateReleaseFromRealtime.ACTION_TYPE);
    }
}

const middleware = async (): Promise<boolean> => {
    // No backend dispatch — bridge already committed the changes.
    return true;
};

const reducer = (state: StorymapState, action: UpdateReleaseFromRealtime): void => {
    const release = state.releases.find((x) => x.id === action.id);
    if (!release) {
        // Release not found in store (may be archived or not visible). No-op.
        return;
    }

    release.name = action.name;
    // Normalize null/undefined goal to empty string to match store contract
    // (Release.goal is a required string; saveNewRelease.ts normalizes missing goal)
    release.goal = action.goal ?? '';
    release.startDate = action.startDate;
    release.releaseDate = action.releaseDate;
    // isReleased is silently ignored — not in store type (§2.2 Non-Goal 7)
};

//@ts-ignore
registerMiddleware(UpdateReleaseFromRealtime.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(UpdateReleaseFromRealtime.ACTION_TYPE, reducer);
